import { useEffect, useRef, useState } from "react";
import { AxiosPublic, BaseURL } from "../../config/axios";
import HeroHeader from "../../Components/hero-header-section/index.section";
import { Pagination } from "@nextui-org/react";
import paginationHelper from "../../helper/paginationHelper";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { getBanner } from "../../api-route/baner";

const Blogs = () => {
    const [searchParams] = useSearchParams();
    const page = searchParams.get('page') || 1;
    const navigate = useNavigate();

    const pagination = useRef()
    const [blogs, setBlogs] = useState([])
    const [loading, setLoading] = useState(true)

    const [texts, setTexts] = useState({ baner: [] })
    useEffect(() => {
        const get = async () => {
            const data = await getBanner(5)
            setTexts(data ? data : {})
        }
        get()
    }, []);

    useEffect(() => {
        const get = async () => {
            await AxiosPublic.get(`blog?page=${page}`)
                .then(({ data }) => {
                    const { data: Data } = data
                    setBlogs(Data.data)
                    pagination.current = Data ? Math.ceil(Data.total / Data.per_page) : 1
                })
                .catch(err => alert(err.response?.data.message || 'مشکلی رخ داده است'))
                .finally(() => setLoading(false))
        }
        get()
    }, [page]);

    const handlePage = (page) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', page);
        navigate({ search: `?${newParams.toString()}` }, { replace: true });
        paginationHelper()
    }

    return (
        <>
            <HeroHeader {...texts} breadcrumb={[{ slug: 'blogs', name: 'مجله هنری' }]} />
            <div className="container mt-5">
                {texts?.header3 && <h3 className="title text-primary mb-6">{texts?.header3}</h3>}
                {texts?.header4 && <h5 className="text-center text-red-900 mb-6">{texts?.header4}</h5>}
                {loading ? <p className="text-center text-xl">... درحال بارگزاری</p> :
                    <main className="overflow-hidden" dir="rtl">
                        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3">
                            {blogs.map((s, i) => (
                                <Link to={`/blogs/${s.slug}`}
                                    className="bg-[#f6f6f6] flex flex-col items-center overflow-hidden sm:rounded-lg"
                                    key={s.id}>
                                    <div className="grow w-full border-b">
                                        <div className="max-h-[250px] h-full overflow-hidden centerOfParent">
                                            <img
                                                className="object-contain w-full h-full max-h-[250px]"
                                                src={BaseURL + s.images[0]?.path} title={s.title}
                                                alt={s.title} placeholder='blur' blurDataURL='/images/placeholder-1.png'
                                                width={100} height={100}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex flex-col items-center p-2 w-full">
                                        <h4 className="w-full  font-bold text-center line-clamp-3">
                                            {s.title}
                                        </h4>
                                        <button
                                            className="bg-primary px-4 py-2 mt-2 rounded-md text-white hover:opacity-80">
                                            مشاهده
                                        </button>
                                    </div>
                                </Link>
                            ))}
                        </div>
                        <div dir="auto" className="centerOfParent mt-4">
                            {!!blogs.length && pagination.current > 1 &&
                                <Pagination size='sm'
                                    total={Math.ceil(pagination.current)}
                                    color="primary"
                                    page={Number(page)}
                                    onChange={handlePage}
                                    showControls
                                />}
                        </div>
                    </main>
                }
            </div>
        </>
    );
}
export default Blogs;
